module.exports = __webpack_public_path__ + "static/Beqom-6ca500dfbc313b7311d98c02d52240af.jpg";